export enum FlexJsClient {
  conversationsClient = "conversationsClient",
  voiceClient = "voiceClient",
  workerClient = "workerClient"
}
